import { gql } from '@apollo/client';

const CLASSROOM_PRIVILEGE_FRAGMENT = gql`
  fragment BaseClassroomPrivilege on ClassroomPrivilege {
    id
    name
    displayName
  }
`;

export default CLASSROOM_PRIVILEGE_FRAGMENT;
